import { FC } from "react";
import { Modal } from "components/Modal";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { CompetencyRatingsChart } from "components/Charts";

type SubRequirementsModalProps = {
  open: boolean;
  onClose: () => void;
  iterName: string;
  subRequirements: Array<{
    requirement_id: string;
    name: string;
    description?: string | null;
  }>;
  ratingsByRequirement?: Record<
    string,
    {
      date: string;
      learnerRating?: number | null;
      coachRating?: number | null;
    }[]
  >;
};

export const SubRequirementsModal: FC<SubRequirementsModalProps> = ({
  open,
  onClose,
  iterName,
  subRequirements,
  ratingsByRequirement = {},
}) => {
  return (
    <Modal open={open} onClose={onClose} title={`${iterName} - Competencies`}>
      <Box mt={2}>
        {subRequirements.length > 0 ? (
          <List>
            {subRequirements.map((subReq) => (
              <ListItem
                key={subReq.requirement_id}
                sx={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                <ListItemText
                  primary={subReq.name}
                  secondary={subReq.description || null}
                />
                <Box mt={1} width="100%">
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Progress Over Time (Learner and Coach Ratings)
                  </Typography>
                  {ratingsByRequirement[subReq.requirement_id] &&
                  ratingsByRequirement[subReq.requirement_id].length > 0 ? (
                    <CompetencyRatingsChart
                      data={ratingsByRequirement[subReq.requirement_id]}
                      height={180}
                    />
                  ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      No ratings data available yet
                    </Typography>
                  )}
                </Box>
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No competencies found
          </Typography>
        )}
      </Box>
    </Modal>
  );
};

